<style scoped>
    .stack-i .fa-arrow-right {
        position: absolute;
        top: 5px;
        left: 7px;
    }
    a {
        text-decoration: none;
    }
    a:hover {
        text-decoration: underline;
    }
    .form-check-input { 
        margin-top: 0.1em;
    }
</style>

<template>
    <div>
        <div v-if="!!isOrder">
            <div v-html="title"></div>
            <hr class="mt-0">
            <table class="table table-bordered table-hover">
                <thead>
                <tr class="text-center bg-supplying">
                    <th style="width: 30px"></th>
                    <th style="width: 30px"></th>
                    <th style="width: 90px;"># PO</th>
                    <th style="width: 150px;">Fournisseur</th>
                    <th>Réquisition</th>
                    <th>Contact</th>
                    <th>Destination</th>
                    <th>Adresse</th>
                    <th>Date&nbsp;Commandée</th>
                    <th>Livraison&nbsp;Confirmée</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="order in list" class="align-middle">
                    <td class="text-center">
                        <template v-if="order.moNumber === null">
                            <input type="checkbox" class="form-check-input" v-model="order.is_order" v-ges-tip="'Réquisitionner commande'" />
                        </template>
                    </td>
                    <td class="text-center">
                        <template v-if="order.moNumber !== null 
                            && (order.moNumber.includes(MaterialOperationTypeEnum.BC.prefix) 
                                || order.moNumber.includes(MaterialOperationTypeEnum.BI.prefix) 
                                || order.moNumber.includes(MaterialOperationTypeEnum.AI.prefix))"
                        >
                            <span v-ges-tip="'Matériel à recevoir'">
                                <i class="fa-solid fa-industry text-purple-600"></i>
                            </span>
                        </template>
                        <template v-else-if="order.moNumber !== null">
                            <span v-ges-tip="'Matériel réquisitionné'">
                                <i v-if="order.moNumber.includes(MaterialOperationTypeEnum.MC.prefix)" class="fa-solid fa-industry"></i>
                                <img v-else class="inventory-img inventory-img-sm inline-block" src="/src/assets/shelf.svg" alt="" />
                            </span>
                        </template>
                        <template v-else-if="order.moNumber === null">
                            <span v-ges-tip="'Matériel à réquisitionner'">
                                <i class="fa-solid fa-list-ol"></i>
                            </span>
                        </template>
                    </td>
                    <td class="text-center">
                        <template v-if="order.moNumber === null">
                            <a href="javascript:void(0)" @click.prevent="showMCPreview(order)" :disabled="order.delivery_address_id === undefined"
                                v-ges-tip="'Voir aperçu'"
                            >
                                {{ order.isInventoryOnly || order.moType === MaterialOperationTypeEnum.MI.id 
                                    ? MaterialOperationTypeEnum.MI.prefix 
                                    : MaterialOperationTypeEnum.MC.prefix }}-0
                            </a>
                        </template>
                        <template v-else>
                            <a href="javascript:void(0)" :class="(order.moType === MaterialOperationTypeEnum.BC.id) ? 'text-purple-600': 'text-blue-600'" 
                                @click="printMaterial(order, order.iteration)"
                            >
                                {{ order.moNumber }}<span v-if="order?.iteration > 0">.{{ order.iteration }}</span>
                            </a>
                        </template>
                    </td>
                    <td>{{ (order.isInventoryOnly || order.moType === MaterialOperationTypeEnum.MI.id) ? getCieById(defaultCie).name : order.cie_name }}</td>
                    <td>{{ order.req_code }}</td>
                    <td>
                        <select class="form-select form-select-sm" v-model="order.vendorContact" :disabled="order.moNumber !== null">
                            <option v-for="contact in getContactForCie(order.cie_id, order)" :value="contact"
                                    :disabled="contact.is_active === 0" :class="{'text-red-bright': contact.is_active === 0}">
                                <ContactLabel :contact="contact" :cie="getCieById(order.cie_id)"></ContactLabel>
                            </option>
                        </select>
                    </td>
                    <td>
                        <select class="form-select form-select-sm" v-model="order.dispatch_received_cie_id"
                            @change="order.delivery_address_id = undefined" :disabled="order.moNumber !== null"
                        >
                            <option v-for="cie in cies" :value="cie.id">{{ cie.name }}</option>
                        </select>
                    </td>
                    <td>
                        <select class="form-select form-select-sm" v-model="order.delivery_address_id" :disabled="order.moNumber !== null">
                            <option v-for="address in getDeliveryAddresses(order.dispatch_received_cie_id, order)" :value="address.id">
                                {{ address.full_name_delivery }}
                            </option>
                        </select>
                    </td>
                    <td class="text-center">
                        <template v-if="order.moNumber !== null">
                            {{ this.$general.formatDate(order.date) }}
                        </template>
                    </td>
                    <td class="text-center">
                        <template v-if="order.moNumber !== null">
                            {{ this.$general.formatDate(order.date_delivery_confirmed) }}
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-else-if="!!isReturn">
            <div v-html="title"></div>
            <hr class="mt-0">
            <table class="table table-bordered table-hover">
                <thead>
                <tr class="text-center bg-supplying">
                    <th style="width: 30px"></th>
                    <th style="width: 30px"></th>
                    <th style="width: 90px;"># PO</th>
                    <th style="width: 150px">Fournisseur</th>
                    <th>Réquisition</th>
                    <th>Contact</th>
                    <th>Destination</th>
                    <th>Adresse</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="returnInfo in list" class="align-middle">
                    <td class="text-center">
                        <template v-if="returnInfo.moNumber === null">
                            <input type="checkbox" class="form-check-input" v-model="returnInfo.is_return" v-ges-tip="'Réquisitionner retour'" />
                        </template>
                    </td>
                    <td class="text-center">
                        <template v-if="returnInfo.moNumber !== null && returnInfo.moNumber.includes(MaterialOperationTypeEnum.RM.prefix)">
                            <span class="stack stack-i">
                                <i class="fa-solid fa-industry text-purple-600"></i>
                                <i class="fa-solid fa-arrow-right text-red-600 fa-stack-1x"></i>
                            </span>
                        </template>
                        <template v-else>
                            <span v-ges-tip="`${MaterialOperationTypeEnum.RM.prefix} à réquisitionner`">
                                <i class="fa-solid fa-list-ol"></i>
                            </span>
                        </template>
                    </td>
                    <td class="text-center">
                        <template v-if="returnInfo.moNumber === null">
                            -
                        </template>
                        <template v-else>
                            <a href="javascript:void(0)" :class="(returnInfo.moType === MaterialOperationTypeEnum.RM.id) ? 'text-purple-600': 'text-blue-600'" 
                                @click="printMaterial(returnInfo)"
                            >
                                {{ returnInfo.moNumber }}
                            </a>
                        </template>
                    </td>
                    <td>{{ returnInfo.cie_name }}</td>
                    <td>{{ returnInfo.req_code }}</td>
                    <td>
                        <select class="form-select form-select-sm" v-model="returnInfo.vendorContact" :disabled="returnInfo.moNumber !== null">
                            <option v-for="contact in getContactForCie(returnInfo.cie_id, returnInfo)" :value="contact"
                                    :disabled="contact.is_active === 0" :class="{'text-red-bright': contact.is_active === 0}">
                                <ContactLabel :contact="contact" :cie="getCieById(returnInfo.cie_id)"></ContactLabel>
                            </option>
                        </select>
                    </td>
                    <td>
                        <select class="form-select form-select-sm" v-model="returnInfo.cie_id" @change="returnInfo.delivery_address_id = undefined" disabled>
                            <option v-for="cie in cies" :value="cie.id">{{ cie.name }}</option>
                        </select>
                    </td>
                    <td>
                        <select class="form-select form-select-sm" v-model="returnInfo.delivery_address_id" :disabled="returnInfo.moNumber !== null">
                            <option v-for="address in getDeliveryAddresses(returnInfo.cie_id, returnInfo)" :value="address.id">{{ address.full_name_delivery }}</option>
                        </select>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-else-if="!!isInventoryReturn">
            <div v-html="title"></div>
            <hr class="mt-0">
            <table class="table table-bordered table-hover">
                <thead>
                <tr class="text-center bg-supplying">
                    <th style="width: 30px"></th>
                    <th style="width: 30px"></th>
                    <th style="width: 90px;"># PO</th>
                    <th>Réquisition</th>
                    <th>Responsable</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="returnInfo in list" class="align-middle">
                    <td class="text-center" style="height: 38.38px;">
                        <template v-if="returnInfo.moNumber === null">
                            <input type="checkbox" class="form-check-input" v-model="returnInfo.is_return" v-ges-tip="'Réquisitionner retour'" />
                        </template>
                    </td>
                    <td class="text-center">
                        <template v-if="returnInfo.moNumber !== null && returnInfo.moNumber.includes(MaterialOperationTypeEnum.RM.prefix)">
                            <span class="stack stack-i">
                                <i class="fa-solid fa-industry text-purple-600"></i>
                                <i class="fa-solid fa-arrow-right text-red-600 fa-stack-1x"></i>
                            </span>
                        </template>
                        <template v-if="returnInfo.moNumber !== null && returnInfo.moNumber.includes(MaterialOperationTypeEnum.RI.prefix)">
                            <span class="stack">
                                <img src="@/assets/shelf.svg" class="ps-1" alt="" style="max-width: 20px">
                                <i class="fa-solid fa-arrow-right text-red-600 fa-stack-1x" style="left: 3px; top:9px"></i>
                            </span>
                        </template>
                        <template v-else>
                            <span v-ges-tip="`${MaterialOperationTypeEnum.RI.prefix} à réquisitionner`">
                                <i class="fa-solid fa-list-ol"></i>
                            </span>
                        </template>
                    </td>
                    <td class="text-center">
                        <template v-if="returnInfo.moNumber === null">
                            -
                        </template>
                        <template v-else>
                            <a href="javascript:void(0)" class='text-blue-600' @click="printMaterial(returnInfo)">
                                {{ returnInfo.moNumber }}
                            </a>
                        </template>
                    </td>
                    <td>{{ returnInfo.req_code }}</td>
                    <td>{{ returnInfo.creator_full_name }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-else-if="!!isHistory">
            <div v-html="title"></div>
            <hr class="mt-0">
            <table class="table table-bordered table-hover">
                <thead>
                    <tr class="text-center bg-supplying">
                        <th style="width: 30px"></th>
                        <th style="width: 30px"></th>
                        <th style="width: 90px;"># PO</th>
                        <th style="width: 150px;">Fournisseur</th>
                        <th>Réquisition</th>
                        <th>Contact</th>
                        <th>Destination</th>
                        <th>Adresse</th>
                        <th>Date&nbsp;Commandée</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="mo in list" class="align-middle">
                        <td class="text-center">
                            <input type="checkbox" class="form-check-input" v-model="mo.is_order" v-ges-tip="'Réquisitionner modification commande'" />
                        </td>
                        <td class="text-center">
                            <span v-ges-tip="'Modification à réquisitionner'">
                                <i class="fa-solid fa-list-ol"></i>
                            </span>
                        </td>
                        <td class="text-center">
                            <a href="javascript:void(0)" class="text-purple-600" @click="printMaterial(mo.material_operation, mo.iteration)">
                                {{ mo.material_operation.type.prefix }}-{{ mo.material_operation.operation_number }}.{{ mo.iteration }}
                            </a>
                        </td>
                        <td class="text-center">
                            {{ mo.material_operation.from_cie.name }}
                        </td>
                        <td class="text-center">
                            {{ mo.material_operation.title }}
                        </td>
                        <td>
                            <select class="form-select form-select-sm" v-model="mo.material_operation.from_cie_contact" disabled>
                                <option v-for="contact in getContactForCie(mo.material_operation.supplier_cie_id, mo.material_operation)" :value="contact"
                                        :disabled="contact.is_active === 0" :class="{'text-red-bright': contact.is_active === 0}">
                                    <ContactLabel :contact="contact" :cie="getCieById(mo.cie_id)"></ContactLabel>
                                </option>
                            </select>
                        </td>
                        <td>
                            <select class="form-select form-select-sm" v-model="mo.material_operation.dispatch_received_cie_id" disabled>
                                <option v-for="cie in cies" :value="cie.id">{{ cie.name }}</option>
                            </select>
                        </td>
                        <td>
                            <select class="form-select form-select-sm" v-model="mo.material_operation.delivery_address_id" disabled>
                                <option v-for="address in getDeliveryAddresses(mo.material_operation.dispatch_received_cie_id, mo.material_operation)"
                                        :value="address.id">{{ address.full_name_delivery }}
                                </option>
                            </select>
                        </td>
                        <td class="text-center">
                            {{ this.$general.formatDate(mo.date) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

    import ContactLabel from "@/components/_shared/ContactLabel.vue";

    export default {
        name: 'OrderPopupList',
        components: {ContactLabel},
        props: {
            title: String,
            list: Array,
            cies: Array,
            isOrder: Boolean,
            isReturn: Boolean,
            isInventoryReturn: Boolean,
            isHistory: Boolean,
        },
        data() {
            return {};
        },
        computed: {
            defaultCie() {
                return parseInt(this.$store.constantStore.getConstantByVariable('NO_CIE_DEFAULT').value);
            },
            MaterialOperationTypeEnum() {
                return this.$store.enumsStore.MaterialOperationType;
            },
            AddressTypeEnum() {
                return this.$store.enumsStore.AddressType;
            }
        },
        methods: {
            getContactForCie(cieId, details) {
                if (this.cies.length === 0) { return; }

                if(details?.isInventoryOnly || details.moType === this.MaterialOperationTypeEnum.MI.id) {
                    cieId = this.defaultCie;
                    details.bc_contact_id = details.supplier_order_contact_id = null;
                }
                const cie = this.getCieById(cieId);

                if (details.vendorContact === undefined || Object.keys(details.vendorContact).length === 0) {
                    if (details.supplier_order_contact_id > 0 || details.bc_contact_id > 0) {
                        const contact_id = details.supplier_order_contact_id ?? details.bc_contact_id;
                        details.vendorContact = cie.contact.find(contact => contact.id === contact_id);
                    } else if (cie.bc_contact_id > 0) {
                        details.vendorContact = cie.contact.find(contact => contact.id === cie.bc_contact_id);
                    } else {
                        details.vendorContact = cie.contact[0];
                    }
                }

                return this.$general.orderByCustom(cie.contact, 'full_name', true);
            },
            getDeliveryAddresses(cieId, details) {
                const cie = this.getCieById(cieId);
                let addresses = cie?.address?.filter(address => address.address_type_id === this.AddressTypeEnum.SHIPPING.id);

                if (!!addresses && addresses.length > 0) {
                    addresses.forEach(address => {
                        address.full_name_delivery = `Livraison ${address.order} (${address.address})`;
                    });

                    if (details.delivery_address_id === null) {
                        details.delivery_address_id = addresses[0].id;
                    }
                } else {
                    addresses = [];
                }

                return addresses;
            },
            printMaterial(materialOperation, moHistoryIteration = null, isPreview = null) {
                let params;
                if (!!isPreview) {
                    materialOperation.moType = (materialOperation.isInventoryOnly ? this.MaterialOperationTypeEnum.MI.id : this.MaterialOperationTypeEnum.MC.id );
                    params = {id: {
                        cie_id: materialOperation.cie_id,
                        requisition_id: materialOperation.requisition_id,
                        moNumber: 0,
                        bc_contact_id: materialOperation.vendorContact.id,
                        req_code: materialOperation.req_code,
                        dispatch_received_cie_id: materialOperation.dispatch_received_cie_id,
                        delivery_address_id: materialOperation.delivery_address_id,
                        part_group: (materialOperation.part_group.is_inventory) ? materialOperation.part_group : null,
                        isInventoryOnly: materialOperation.isInventoryOnly ?? null
                    }};
                } else {
                    params = moHistoryIteration ? {id: materialOperation.id, moHistoryIteration: moHistoryIteration} : {id: materialOperation.mo_id};
                }

                this.$parent.$parent.showPrintPopup();
                this.$axios.pdf(
                    ((materialOperation.moStatus == this.MaterialOperationTypeEnum.RM.status) ? '/PrintReturn' : '/PrintOrder'),
                    params
                ).then((response) => {
                    const filename = materialOperation.moNumber ?? (materialOperation.isInventoryOnly 
                        ? this.MaterialOperationTypeEnum.MI.prefix 
                        : this.MaterialOperationTypeEnum.MC.prefix )+'-0';
                    this.$store.pdfviewer.open(response, filename);
                    this.$parent.$parent.$refs.printToast.hide();
                });
            },
            getCieById(cieId) {
                return this.cies?.find(cie => cie.id === cieId);
            },
            showMCPreview(order) {
                const isPreview = true;
                this.printMaterial(order, null, isPreview);
            },
        },
        watch: {
        },
    };
</script>